enum TopLevelMethod {
  CREATE_PAGE_VIEWER = "Jigsaw.createPageViewer",
  CREATE_SNIPPET_VIEWER = "Jigsaw.createSnippetViewer",
  GET_USER_INFO = "Jigsaw.User.getInfo",
  SET_USER_INFO = "Jigsaw.User.setInfo",
  SIGN_OUT = "Jigsaw.User.signOut",
  ENABLE_LAB = "Jigsaw.Labs.enable",
  DISABLE_LAB = "Jigsaw.Labs.disable",
  GET_MARKERS = "Jigsaw.Markers.getMarkers",
  CREATE_MARKER = "Jigsaw.Markers.createMarker",
  DELETE_MARKER = "Jigsaw.Markers.deleteMarker",
  UPDATE_MARKER = "Jigsaw.Markers.updateMarker",
  GET_FOLLOWINGS = "Jigsaw.Sharing.getFollowings",
  UNFOLLOW = "Jigsaw.Sharing.unfollow",
  FOLLOW = "Jigsaw.Sharing.follow",
  LOOKUP_TERM = "Jigsaw.Dictionary.lookup",
  SEARCH_BOOK = "Jigsaw.Search.search",
  CREATE_LTI_LAUNCH = "Jigsaw.User.createLTILaunch",
  ANCILLARIES_GET_SUMMARY = "Jigsaw.Ancillaries.getSummary",
  ANCILLARIES_GET_FOR_VBID = "Jigsaw.Ancillaries.getForVbid",
  ANCILLARIES_GET_ALL_ACCESSCODES = "Jigsaw.Ancillaries.getAllAccessCodes",
  ANCILLARIES_REDEEM = "Jigsaw.Ancillaries.redeem",
  UPDATE_USER_PREFS = "Jigsaw.User.updatePreferences",
  GET_BOOK_INFO = "Jigsaw.Book.getInfo",
}

export default TopLevelMethod;
